import { GlIcon, GlTooltipDirective } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { formatTime } from '~/lib/utils/datetime_utility';
import timeagoMixin from '~/vue_shared/mixins/timeago';
export default {
    name: 'PipelinesTimeago',
    directives: {
        GlTooltip: GlTooltipDirective
    },
    components: {
        GlIcon
    },
    mixins: [
        timeagoMixin
    ],
    props: {
        pipeline: {
            type: Object,
            required: true
        }
    },
    computed: {
        duration () {
            return this.pipeline?.details?.duration ?? this.pipeline?.duration;
        },
        durationFormatted () {
            if (typeof this.duration === 'number') {
                return formatTime(this.duration * 1000);
            }
            return '';
        },
        finishedTime () {
            return this.pipeline?.details?.finished_at || this.pipeline?.finishedAt;
        }
    }
};
